<template>
  <div>
    <div class="search-chat"
       @click="openSearch"

    >
      <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="10.3524" cy="10.3524" rx="9.35238" ry="9.35238" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.8571 17.3428L20.5238 21" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="search-mess"
       ref="close"
    >
      <v-btn tag="a" text  class="search-btn">
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="10.3524" cy="10.3524" rx="9.35238" ry="9.35238" stroke="#96AFD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.8571 17.3428L20.5238 21" stroke="#96AFD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </v-btn>

      <v-menu content-class="result" offset-y v-model="search_list" :close-on-content-click="true">
        <template v-slot:activator="{on, attr}">
          <span @click="openSearch" class="close">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M10 0C8.1901 0 6.51693 0.445964 4.98047 1.33789C3.44401 2.22982 2.22982 3.44401 1.33789 4.98047C0.445964 6.51693 0 8.1901 0 10C0 11.8099 0.445964 13.4831 1.33789 15.0195C2.22982 16.556 3.44401 17.7702 4.98047 18.6621C6.51693 19.554 8.1901 20 10 20C11.8099 20 13.4831 19.554 15.0195 18.6621C16.556 17.7702 17.7702 16.556 18.6621 15.0195C19.554 13.4831 20 11.8099 20 10C20 8.1901 19.554 6.51693 18.6621 4.98047C17.7702 3.44401 16.556 2.22982 15.0195 1.33789C13.4831 0.445964 11.8099 0 10 0ZM10 18.7695C9.04948 18.7695 8.12825 18.623 7.23633 18.3301C6.3444 18.0371 5.54036 17.6172 4.82422 17.0703C4.10807 16.5234 3.47982 15.8919 2.93945 15.1758C2.39909 14.4596 1.98242 13.6556 1.68945 12.7637C1.39648 11.8717 1.25 10.9505 1.25 10C1.25 8.8151 1.48112 7.68229 1.94336 6.60156C2.4056 5.52083 3.02734 4.58984 3.80859 3.80859C4.58984 3.02734 5.52083 2.4056 6.60156 1.94336C7.68229 1.48112 8.8151 1.25 10 1.25C11.1849 1.25 12.3177 1.48112 13.3984 1.94336C14.4792 2.4056 15.4102 3.02734 16.1914 3.80859C16.9727 4.58984 17.5944 5.52083 18.0566 6.60156C18.5189 7.68229 18.75 8.8151 18.75 10C18.75 11.1849 18.5189 12.3177 18.0566 13.3984C17.5944 14.4792 16.9727 15.4134 16.1914 16.2012C15.4102 16.9889 14.4792 17.6139 13.3984 18.0762C12.3177 18.5384 11.1849 18.7695 10 18.7695ZM13.5352 6.46484C13.418 6.34766 13.2715 6.28906 13.0957 6.28906C12.9199 6.28906 12.7734 6.34766 12.6562 6.46484L10 9.12109L7.34375 6.46484C7.22656 6.34766 7.08008 6.28906 6.9043 6.28906C6.72852 6.28906 6.58203 6.34766 6.46484 6.46484C6.34766 6.58203 6.28906 6.72852 6.28906 6.9043C6.28906 7.08008 6.34766 7.22656 6.46484 7.34375L9.12109 10L6.46484 12.6562C6.38672 12.7344 6.33138 12.8255 6.29883 12.9297C6.26628 13.0339 6.26628 13.1413 6.29883 13.252C6.33138 13.3626 6.38672 13.457 6.46484 13.5352C6.58203 13.6523 6.72852 13.7109 6.9043 13.7109C7.08008 13.7109 7.22656 13.6523 7.34375 13.5352L10 10.8789L12.6562 13.5352C12.7734 13.6523 12.9199 13.7109 13.0957 13.7109C13.2715 13.7109 13.418 13.6523 13.5352 13.5352C13.6133 13.457 13.6686 13.3626 13.7012 13.252C13.7337 13.1413 13.7337 13.0339 13.7012 12.9297C13.6686 12.8255 13.6133 12.7344 13.5352 12.6562L10.8789 10L13.5352 7.34375C13.6523 7.22656 13.7109 7.08008 13.7109 6.9043C13.7109 6.72852 13.6523 6.58203 13.5352 6.46484Z" fill=""/>
            </svg>
          </span>
          <SearchDefault
            class_search="message_search"
            v-model="search"
            :placeholder='__("Search ...")'
            v-on:keyup.enter="(submitDisabled) ? null :searchMessage()"
            @searching="(submitDisabled) ? null :searchMessage()"
            v-on="on"
            v-bind="attr"
          >
          </SearchDefault>

        </template>
        <v-list class="result-list pa-0" v-if="search">
          <v-list-item class="pa-0">
            <div v-if="messages_list" class="list-list">
              <ul class="search-result" style="">
                <li v-for="(message, key) in messages_list.data" :key="key" class="" v-on:click="$emit('scrollToMessage', message)">
                  <v-list color="transparent" class="pa-0 mr-4" v-if="message.opp_type== 1">
                    <v-list-item class="px-0">
                      <router-link :to="{name: 'profile', params: {id: user.public_id, lang: $store.getters.getLang}}" class="wrap-img" :class="(user.pro) ? 'user-pro-img' : ''">
                        <div class="block-img">
                          <img v-if="auth.photo && typeof auth.photo == 'object'" :src="auth.photo[40]" />
                          <img v-else-if="auth.photo" :src="auth.photo" />
                          <span v-else class="photo" :style="{'background': user.bg_color}">{{user.name.substr(0,1)}}</span>
                        </div>
                      </router-link>
                      <v-list-item-content>
                        <v-list-item-title>
                          <router-link :class="(user.pro) ? 'user-pro' : ''" :to="{name: 'profile', params: {id: user.public_id, lang: $store.getters.getLang}}">{{user.name +' '+((user.last_name) ? user.last_name : '')}}</router-link>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list color="transparent" class="pa-0 mr-4" v-if="message.opp_type== 2">
                    <v-list-item class="px-0">
                      <router-link :to="{name: 'profile', params: {id: auth.public_id, lang: $store.getters.getLang}}" class="wrap-img">
                        <div class="block-img">
                          <img v-if="auth.photo && typeof auth.photo == 'object'" :src="auth.photo[40]" />
                          <img v-else-if="auth.photo" :src="auth.photo" />
                          <span v-else class="photo" :style="{'background': auth.bg_color}">{{auth.name.substr(0,1)}}</span>
                        </div>
                      </router-link>
                      <v-list-item-content>
                        <v-list-item-title><router-link :to="{name: 'profile', params: {id: auth.public_id, lang: $store.getters.getLang}}">{{auth.name +' '+((auth.last_name) ? auth.last_name : '')}}</router-link></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <span class="mess">{{message.message}}</span>
                </li>
              </ul>
            </div>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
    import SearchDefault from "../../modules/SearchDefault";

    export default {
        name: 'SearchMessages',
        data: function() {
            return {
                search: null,
                submitDisabled: false,
                messages_list: false,
                loadingPage: false,
                search_list: false
            }
        },
        props: {
            user: {
                type: Object
            },
        },
        computed: {
            auth() {
                return this.$store.state.auth.user
            },
        },
        watch: {
            nav_search() {
                this.search_list= this.nav_search;
            }
        },
        created() {

        },
        methods: {
            openSearch: function () {
                this.$refs.close.classList.toggle('active');
            },
            searchMessage: function() {
                if(!this.submitDisabled) {
                    let search= this.search;
                    if(search) {

                        let response= {
                            search: search,
                            user_id: this.user.to
                        };

                        this.submitDisabled= true;
                        this.messages_list= false;
                        this.$http.post("ajax/chat/search/message", response)
                            .then(response=> {
                                return response.json()
                            })
                            .then((response)=> {
                                if(this.$checkAuth(response)) {
                                    // response= {
                                    //     "data": {
                                    //         "current_page": 1,
                                    //         "data": [
                                    //             {
                                    //                 "id": "1212314671",
                                    //                 "user_id": 418079082,
                                    //                 "to": 2,
                                    //                 "read": "1",
                                    //                 "message": "sda",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-03 13:51:51",
                                    //                 "opp_type": "1",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             },
                                    //             {
                                    //                 "id": "823587147",
                                    //                 "user_id": 2,
                                    //                 "to": 418079082,
                                    //                 "read": "1",
                                    //                 "message": "sdasda sdadsasad\\nsdadsa",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-02 14:39:04",
                                    //                 "opp_type": "2",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             },
                                    //             {
                                    //                 "id": "165811529",
                                    //                 "user_id": 418079082,
                                    //                 "to": 2,
                                    //                 "read": "1",
                                    //                 "message": "qewsda dsa\\nads",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-02 14:38:50",
                                    //                 "opp_type": "1",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             },
                                    //             {
                                    //                 "id": "237527680",
                                    //                 "user_id": 2,
                                    //                 "to": 418079082,
                                    //                 "read": "1",
                                    //                 "message": "sda",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-02 14:38:11",
                                    //                 "opp_type": "2",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             },
                                    //             {
                                    //                 "id": "1039953623",
                                    //                 "user_id": 2,
                                    //                 "to": 418079082,
                                    //                 "read": "1",
                                    //                 "message": "asdsda",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-02 14:38:05",
                                    //                 "opp_type": "2",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             },
                                    //             {
                                    //                 "id": "1454100205",
                                    //                 "user_id": 418079082,
                                    //                 "to": 2,
                                    //                 "read": "1",
                                    //                 "message": "sadsda",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-02 14:37:55",
                                    //                 "opp_type": "1",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             },
                                    //             {
                                    //                 "id": "1640608094",
                                    //                 "user_id": 418079082,
                                    //                 "to": 2,
                                    //                 "read": "1",
                                    //                 "message": "sda",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-02 14:37:51",
                                    //                 "opp_type": "1",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             },
                                    //             {
                                    //                 "id": "1127494350",
                                    //                 "user_id": 418079082,
                                    //                 "to": 2,
                                    //                 "read": "1",
                                    //                 "message": "dassda",
                                    //                 "resend_id": null,
                                    //                 "message_id": null,
                                    //                 "message_at": null,
                                    //                 "created_at": "2021-02-02 14:37:43",
                                    //                 "opp_type": "1",
                                    //                 "resend": null,
                                    //                 "user": null
                                    //             }
                                    //         ],
                                    //         "first_page_url": "https://mindplay.loc/ajax/chat/messages?page=1",
                                    //         "from": 1,
                                    //         "last_page": 1,
                                    //         "last_page_url": "https://mindplay.loc/ajax/chat/messages?page=1",
                                    //         "next_page_url": null,
                                    //         "path": "https://mindplay.loc/ajax/chat/messages",
                                    //         "per_page": 24,
                                    //         "prev_page_url": null,
                                    //         "to": 22,
                                    //         "total": 22
                                    //     },
                                    //     "status": 200
                                    // };


                                    this.submitDisabled = false;
                                    this.messages_list = response.data;
                                }
                            }).catch(err => {
                            this.submitDisabled= false;
                            let response= this.httpHandler(err);
                            if(response.error) {
                                this.formValidate = response.error.message;
                            }
                        });
                    }
                }
            },
        },
        components: {
            SearchDefault
        },
    };
</script>
